import React, { Component } from 'react';
import _ from 'lodash';
import { RadioButtonGroup } from 'components';
import Dropdown from 'react-toolbox/lib/dropdown';
import moment from 'moment';
import Input from 'react-toolbox/lib/input';
import Dialog from 'react-toolbox/lib/dialog';
import * as util from 'lib/utility';
import styles from './PopupAdd.css';

const debug = _debug('app:PopupAdd');

class PopupAdd extends Component {
  static propTypes = {
    closeAction: React.PropTypes.func,
    saveContactAction: React.PropTypes.func,
    currentLanguage: React.PropTypes.strings,
    strings: React.PropTypes.shape({}),
  }
  constructor(props) {
    super(props);
    debug(this.state.editRadioValue);
  }
  state = {
    firstNameValue: '',
    lastNameValue: '',
    phoneNumberValue: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    businessFirmName: '',
    editDropdownValue: '',
    editRadioValue: '2',
    comments: '',
    active: false,
    errorMessage: '',
    dbData: '',
    DOB: ''
  };
  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }
  lastNameCallback = (value) => {
    this.setState({ lastNameValue: value });
  };
  firstNameCallback = (value) => {
    this.setState({ firstNameValue: value });
  };
  phoneNumberAction = (phoneNumberData) => {
    let phoneNumber = phoneNumberData;
    if (phoneNumber.length < 13) {
      phoneNumber = phoneNumber.replace(/[^\d]/g, '');
      if (phoneNumber.length > 3) {
        phoneNumber = this.insertInNumber(phoneNumber, 3, '-');
        if (phoneNumber.length > 7) {
          phoneNumber = this.insertInNumber(phoneNumber, 7, '-');
          if (phoneNumber.length > 13) {
            phoneNumber = this.insertInNumber(phoneNumber, 13, '-');
          }
        }
      }
      this.setState({ phoneNumberValue: phoneNumber });
    }
  };
  dobChangeAction = (dobData) => {
    let dob = dobData;
    if (dob.length < 11) {
      dob = dob.replace(/[^\d]/g, '');
      if (dob.length > 2) {
        dob = this.insertInNumber(dob, 2, '/');
        if (dob.length > 5) {
          dob = this.insertInNumber(dob, 5, '/');
        }
      }
      this.setState({ DOB: dob });
    }
  };
  insertInNumber = (s1, index, s2) => {
    const substr = s1.substring(0, index) + s2 + s1.substring(index);
    return substr;
  }
  action = strings => [
    { label: strings.ok, onClick: this.handleToggle }
  ];

  addressAction = (value) => {
    this.setState({ address: value });
  };
  cityChangedAction = (value) => {
    this.setState({ city: value });
  };
  stateChangedAction = (value) => {
    this.setState({ stateValue: value.toUpperCase() });
  };
  zipChangedAction = (value) => {
    this.setState({ zip: value });
  };
  businessFirmAction = (value) => {
    this.setState({ businessFirmName: value });
  };
  commentsAction = (value) => {
    this.setState({ comments: value });
  };
  handleEditDropdownChange = (value) => {
    this.setState({ editDropdownValue: value });
  };
  editRadioChange = (value) => {
    this.setState({ editRadioValue: value });
  };
  saveContactData = () => {
    const firstName = this.state.firstNameValue;
    const lastName = this.state.lastNameValue;
    const strings = this.props.strings;
    const name = `${firstName} ${lastName}`;
    const phoneNumberValue = this.state.phoneNumberValue ?
    this.state.phoneNumberValue.replace(/[^\d]/g, '') : this.state.phoneNumberValue;
    const phoneNumberType = this.state.editDropdownValue;
    let callType = '';
    if (this.state.editRadioValue && this.state.editRadioValue !== '') {
      callType = parseInt(this.state.editRadioValue, 10);
    }
    let isNumberEntered = false;
    let contactData = '';
    let addr1Telephone1 = '';
    let addr1Telephone2 = '';
    let addr2Telephone1 = '';
    let addr1Line1 = '';
    let addr1City = '';
    let addr1Stateorprovince = '';
    let addr1Postalcode = '';
    let addr2Line1 = '';
    let addr2City = '';
    let addr2Stateorprovince = '';
    let addr2Postalcode = '';

    if (phoneNumberType === '1') {
      addr1Telephone1 = phoneNumberValue;
    } else if (phoneNumberType === '2') {
      addr2Telephone1 = phoneNumberValue;
    } else if (phoneNumberType === '3') {
      addr1Telephone2 = phoneNumberValue;
    } else {
      addr1Telephone1 = phoneNumberValue;
    }

    if ((addr1Telephone1 !== '') || (addr1Telephone2 !== '') || (addr2Telephone1 !== '')) {
      isNumberEntered = true;
    }
    if (callType === 1) { // Business
      addr2Line1 = this.state.address;
      addr2City = this.state.city.toLowerCase();
      addr2Stateorprovince = this.state.state;
      addr2Postalcode = this.state.zip;
    } else if (callType === 2) { // Residence
      addr1Line1 = this.state.address;
      addr1City = this.state.city.toLowerCase();
      addr1Stateorprovince = this.state.state;
      addr1Postalcode = this.state.zip;
    }
    if (this.state.DOB && (moment(this.state.DOB).format('MM-DD-YYYY') === 'Invalid date')) {
      this.setState({ active: true, errorMessage: 'Please input DOB in MM/DD/YYYY format' });
      return;
    }
    // const dob = moment(this.state.DOB, 'MM-DD-YYYY').format('MM/DD/YYYY')
    // === 'Invalid date' ? 'N/A' : moment(this.state.DOB, 'MM-DD-YYYY').format('MM/DD/YYYY');
    // console.log('dob:::', dob);
    if (firstName && isNumberEntered) {
      contactData = {
        id: util.generateGUID(),
        lastname: name,
        cica_calltype: callType,
        companyname: this.state.businessFirmName ? this.state.businessFirmName : '',
        cica_comments: this.state.comments,
        mobilephone: phoneNumberValue,
        address1_telephone1: addr1Telephone1,
        address1_telephone2: addr1Telephone2,
        address2_telephone1: addr2Telephone1,
        address1_line1: addr1Line1,
        address1_city: addr1City,
        address1_stateorprovince: addr1Stateorprovince,
        address1_postalcode: addr1Postalcode,
        address2_line1: addr2Line1,
        address2_city: addr2City,
        address2_stateorprovince: addr2Stateorprovince,
        address2_postalcode: addr2Postalcode,
        cica_leadtype: 7,
        cica_leaddispositionstatus: 1,
        cica_assigneddate: `${moment().utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
        cica_phonenumbertype: phoneNumberType,
        cica_isactive: '1',
        cica_pcstate: this.state.stateValue,
        cica_pcstreet: addr1Line1 || addr2Line1,
        cica_pccity: addr1City || addr2City,
        cica_pccounty: addr1Stateorprovince || addr2Stateorprovince,
        cica_pczip: addr1Postalcode || addr2Postalcode,
        cica_dob: this.state.DOB
      };
      this.props.saveContactAction(contactData);
    } else {
      this.setState({ active: true, errorMessage: strings.errorMessage });
    }
  }

  saveContactDataThrottled = () => {
    _.throttle(this.saveContactData(), 60000, { trailing: false });
  }

  radioButtonData = [
    {
      label: this.props.strings && this.props.strings.residence, //eslint-disable-line
      value: '2'
    }, {
      label: this.props.strings && this.props.strings.business, //eslint-disable-line
      value: '1'
    }
  ];
  options = [
    { value: '1', label: 'Home' },
    { value: '2', label: 'Business' },
    { value: '3', label: 'Additional No. (Cell)' }
  ];
  optionsEs = [
    { value: '1', label: 'Residencia' },
    { value: '2', label: 'Negocio' },
    { value: '3', label: 'Número adicional (celular)' }
  ];
  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.mainFieldContainer}>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.firstName}
                </span>
                <span className={styles.labelStar}>
                *
                </span>
                <Input
                  type="text"
                  name="First Name"
                  hint={strings.firstName}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.firstNameCallback}
                  value={this.state.firstNameValue}
                />
              </div>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.lastName}
                </span>
                <Input
                  type="text"
                  name={'Last Name'}
                  hint={strings.lastName}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.lastNameCallback}
                  value={this.state.lastNameValue}
                />
              </div>
            </div>
          </div>
          <div className={styles.fieldContainersDropdown}>
            <div className={styles.phoneContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.phoneNumber}
                </span>
                <span className={styles.labelStar}>
                *
                </span>
                <Input
                  type="tel"
                  name={'Phone Number'}
                  hint={strings.phoneNumber}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.phoneNumberAction}
                  value={this.state.phoneNumberValue}
                />
              </div>
            </div>
            <div className={styles.dropdownHolder}>
              <span className={styles.labelText}>
                {strings.type}
              </span>
              <Dropdown
                auto
                source={this.props.currentLanguage === 'es' ?
                  this.optionsEs : this.options}
                onChange={this.handleEditDropdownChange}
                theme={styles}
                value={this.state.editDropdownValue}
              />
            </div>
          </div>
          <div className={styles.fieldContainersRadio}>
            <span className={styles.labelText}>
              {strings.callType}
            </span>
            <div className={styles.popupRadioInner}>
              <RadioButtonGroup
                name="editRadio"
                value={this.state.editRadioValue}
                themestyles={styles}
                radioStyle={styles.radioStyle}
                radioButtonName={'edit'}
                radioButtonData={this.radioButtonData}
                handleRadioChange={this.editRadioChange}
              />
            </div>
            <div className={styles.placeHolder} />
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.address}
                </span>
                <Input
                  type="text"
                  name={'Address'}
                  hint={strings.address}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.addressAction}
                  value={this.state.address}
                />
              </div>
            </div>
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.dOB}
                </span>
                <Input
                  type="text"
                  pattern="\d*"
                  name={'DOB'}
                  hint={strings.dOB}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.dobChangeAction}
                  value={this.state.DOB}
                />
              </div>
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <span className={styles.labelText}>
                {strings.zipCityState}
              </span>
              <div className={styles.inputHolderSmall}>
                <Input
                  type="number"
                  name={'Zip'}
                  hint={strings.zip}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.zipChangedAction}
                  value={this.state.zip}
                />
                <Input
                  type="text"
                  name={'City'}
                  hint={strings.city}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.cityChangedAction}
                  value={this.state.city}
                />
                <Input
                  type="text"
                  name={'State'}
                  hint={strings.state}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.stateChangedAction}
                  value={this.state.stateValue}
                />
              </div>
            </div>
          </div>
          { (this.state.editRadioValue === '1') ? <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.businessname}
                </span>
                <Input
                  type="text"
                  name={'Business Name'}
                  hint={strings.businessname}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.businessFirmAction}
                  value={this.state.businessFirmName}
                />
              </div>
            </div>
          </div> : null
          }
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig}>
                <span className={styles.labelText}>
                  {strings.comments}
                </span>
                <Input
                  type="text"
                  multiline
                  name={'Comments'}
                  hint={strings.comments}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.commentsAction}
                  value={this.state.comments}
                />
              </div>
            </div>
          </div>

        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onClick={() => this.saveContactDataThrottled()}
            >{strings.save}</button>
            <button
              className={styles.cancelSpan}
              onClick={() => this.props.closeAction()}
            >{strings.cancel}</button>
          </div>
        </div>
        <Dialog
          actions={this.action(strings)}
          active={this.state.active}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          className={styles.alertDialog}
          theme={styles}
        >
          <p>{this.state.errorMessage}</p>
        </Dialog>
      </div>
    );
  }
}
export default PopupAdd;



// WEBPACK FOOTER //
// ./src/containers/PopupAdd/PopupAdd.js